import { useState } from 'react';
import Typography from '../components/Typography';
import ProductHeroLayout from './ProductHeroLayout';
import japanBackgroundImage from '../../static/biz-professional/blue-7914536_1280.jpg';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { styled } from '@mui/system';
import executeScoreHerVoice from '../tools/getPredictionRequest';
import { RECORD_SAMPLING_RATE, VOLUME_THRESHOLD } from '../../consts';
import LinearIndeterminate1sec from '../components/LinearProfress1sec';
import CircularProgress from '@mui/material/CircularProgress';
import {
  Grid,
} from '@mui/material';


import LinearProgress from '@mui/material/LinearProgress';
function LinearIndeterminate() {
  return (
    <Box sx={{ width: '100%' }}>
      <LinearProgress />
    </Box>
  );
}

const backgroundImage = '';

const StyledButton = styled(Button)({
  minWidth: 200,
  marginTop: 1,
  borderRadius: 0,
});

function resampleAudio(
  input: Float32Array,
  inputSampleRate: number,
  outputSampleRate: number
): Float32Array {
  const durationInSeconds = input.length / inputSampleRate;
  const outputLength = Math.floor(durationInSeconds * outputSampleRate);
  const output = new Float32Array(outputLength);

  for (let i = 0; i < outputLength; i++) {
    const inputSampleIndex = (i * inputSampleRate) / outputSampleRate;
    const index1 = Math.floor(inputSampleIndex);
    const index2 = Math.ceil(inputSampleIndex);

    const frac = inputSampleIndex - index1;

    if (index1 >= 0 && index2 < input.length) {
      output[i] = input[index1] + frac * (input[index2] - input[index1]);
    }
  }

  return output;
}

function generateOneSecEquevalentAudioData(audioData: Float32Array, sampleRate: number): Float32Array {
  const X = audioData.length;

  if (X > sampleRate) {
    const removeCount = Math.floor((X - sampleRate) / 2);

    if ((X - sampleRate) % 2 === 0) {
      return audioData.subarray(removeCount, X - removeCount);
    } else {
      return audioData.subarray(removeCount + 1, X - removeCount);
    }
  } else if (X < sampleRate) {
    const addCount = Math.floor((-X + sampleRate) / 2);
    const newArray = new Float32Array(sampleRate);

    if ((-X + sampleRate) % 2 === 0) {
      newArray.set(audioData, addCount);
    } else {
      newArray.set(audioData, addCount + 1);
    }

    return newArray;
  } else {
    return audioData;
  }
}

// Function to calculate the average volume of raw audio data
function calculateAverageVolume(rawAudioData: Float32Array): number {
  let sum = 0;

  // Sum up the absolute values of all the amplitude values
  for (let i = 0; i < rawAudioData.length; i++) {
    sum += Math.abs(rawAudioData[i]);
  }

  // Calculate the average by dividing the sum by the number of samples
  const average = sum / rawAudioData.length;

  return average;
}



export default function ProductHero() {
  const [isRecording, setIsRecording] = useState(false);
  const [finalScore, setFinalScore] = useState<number | string>("");
  const [phase, setPhase] = useState<string>("init");

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      let audioTypeValue: string;
      let recorder: MediaRecorder;
      try {
        audioTypeValue = 'audio/webm';
        recorder = new MediaRecorder(stream, { mimeType: audioTypeValue });
      } catch (error) {
        audioTypeValue = 'video/mp4';
        recorder = new MediaRecorder(stream, { mimeType: audioTypeValue });
      }
      const chunks: Blob[] = [];

      recorder.ondataavailable = (e) => {
        if (e.data.size > 0) {
          chunks.push(e.data);
        }
      };

      recorder.onstop = async () => {
        const audioBlob = new Blob(chunks, { type: audioTypeValue });
        const arrayBuffer = await audioBlob.arrayBuffer();
        console.log(arrayBuffer);

        // Decode audio data using Web Audio API
        const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
        const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

        // Get raw audio data from the first channel
        const rawAudioData = audioBuffer.getChannelData(0);

        // Log the sampling rate
        console.log('Sampling rate:', audioBuffer.sampleRate);
        // Now rawAudioData is an array of numbers representing the raw audio samples
        console.log('Length of rawAudioData:', rawAudioData.length);
        console.log(rawAudioData);

        const averageVolume: number = calculateAverageVolume(rawAudioData);
        console.log('xxxAverage Volume:', averageVolume);

        if (averageVolume > VOLUME_THRESHOLD) {
          console.log('Validation: Yes enough Volume', averageVolume);
          // TODO: validate
          // Example usage:
          const resampledAudio = resampleAudio(rawAudioData, audioBuffer.sampleRate, RECORD_SAMPLING_RATE);
          console.log('Resampled audio data:', resampledAudio);

          const processedAudio = generateOneSecEquevalentAudioData(resampledAudio, RECORD_SAMPLING_RATE);
          console.log('Processed audio data:', processedAudio);

          // test
          // const testAudioData = new Float32Array([1, 2, 1]);
          // const processedtestAudio = generateOneSecEquevalentAudioData(testAudioData, 14);
          // console.log('Processed audio data:', processedtestAudio);

          try {
            const result = await executeScoreHerVoice(processedAudio, RECORD_SAMPLING_RATE);
            console.log(result);
            setFinalScore((100 * result["allData"]["her"]).toFixed(0));
            setPhase("gotScore");
          } catch (error) {
            console.error('Error scoring her voice:', error);
            setFinalScore("Service too busy & currently service not available, sorry");
            setPhase("gotScore");
          }
        } else {
          console.log('Validation: Not enough Volume', averageVolume);
          setFinalScore(" Speak louder please");
          setPhase("gotScore");
        }


      };

      recorder.start();
      setIsRecording(true);
      setPhase("recording");

      // Stop the recorder after the specified duration
      setTimeout(() => {
        recorder.stop();
        setIsRecording(false);
        setPhase("analyzing");
      }, 1300);

      setFinalScore("analyzing");
    } catch (error) {
      console.error('Error accessing microphone:', error);
      setPhase("init");
    }
    setPhase("init");
  };

  return (
    <ProductHeroLayout
      sxBackground={{
        backgroundImage: `url(${japanBackgroundImage})`,
        backgroundColor: '#7fc7d9', // Average color of the background image.
        backgroundPosition: 'center',
      }}
    >
      <img
        style={{ display: 'none' }}
        src={backgroundImage}
        alt="increase priority"
      />
      <Grid container spacing={0} direction="column" justifyContent="space-between" alignItems="center">
        <Grid item xs={12} md={12} lg={12}>
          <Box sx={{ flex: 2 }}>
            <Typography variant="h1" align="center" sx={{ fontSize: 35, color: 'white', fontWeight: 'normal', margin: '40px' }}>
              外資系戦略コンサルに学ぶ<br />
              プレゼンテーションスキルの理論と実践
            </Typography>
            <Typography color="inherit" align="center" variant="h2" marked="center" sx={{ mt: 0 }}>
            </Typography>
          </Box>
          <Box sx={{ flex: 2 }} textAlign='center'>
            <Typography variant="body2" color="inherit" sx={{ fontSize: 20, mt: 1, margin: '40px' }}>
              プレゼンテーション資料作成におけるお作法やフォーマットを紹介するにとどまらず、実務的なコツまでを体系的にご紹介しています。
              初級から中級までのビジネスプロフェッショナルのプレゼンテーションスキル獲得におけるバイブルとなれば幸いです。
              <br /><br />
              なお、本サイトの記事・コンテンツは、外資系戦略コンサルティングファームでの実務経験者が監修しています。
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={12} lg={12}>
          <Typography sx={{ textAlign: 'center' }}>
            <KeyboardDoubleArrowDownIcon color="primary" sx={{ fontSize: 40, mt: 5 }} />
          </Typography>
        </Grid>
      </Grid>
    </ProductHeroLayout >
  );
}
